import { GENERIC_ERROR } from "@/ds";
import {
  DETAIL_SECTION_REAUTH_LABEL,
  DETAIL_SECTION_RETRY_LABEL,
  DETAIL_SECTION_STATE_ICONS,
  DETAIL_SECTION_STATE_VARIANTS,
} from "./detail-section-state.constants";
import type {
  DetailSectionStateMessage,
  DetailSectionStateProps,
} from "./types-detail-section-state";

/**
 * Carregamento e cenários de exceção da seção (AC5): o estado ocupa o lugar dos campos e em nenhum deles um campo
 * parcial é exibido. Sessão expirada oferece "Entrar novamente"; erro genérico, "Tentar novamente".
 */
export function useDetailSectionState({
  status,
  loadingMessage,
  errorMessage,
  emptyContent,
  onReauthenticate,
  onRetry,
  testId,
}: DetailSectionStateProps) {
  const icon =
    status === "sessionExpired" || status === "notFound"
      ? DETAIL_SECTION_STATE_ICONS[status]
      : undefined;
  const action =
    status === "sessionExpired"
      ? { label: DETAIL_SECTION_REAUTH_LABEL, onClick: onReauthenticate }
      : status === "error"
        ? { label: DETAIL_SECTION_RETRY_LABEL, onClick: onRetry }
        : undefined;
  const mensagem: DetailSectionStateMessage | null =
    status === "empty"
      ? null
      : {
          variant: DETAIL_SECTION_STATE_VARIANTS[status],
          title: status === "loading" ? loadingMessage : (errorMessage ?? GENERIC_ERROR),
          icon,
          action,
          testId: `${testId}-${status}`,
        };

  return { emptyContent, emptyTestId: `${testId}-empty`, mensagem };
}
